<template>
  <div>
    <div class="notification-container" @mouseover="handleHover" @mouseleave="hover = false">
      <div class="notification">
        <div class="notification-content">
          <Checkbox
            v-if="(hover && !notification.is_read) || isSelected"
            :checked="isSelected"
            v-on="$listeners"
          />
          <IsReadStatus v-else :is-read="notification.is_read" />
          <Avatar
            v-if="user"
            :size="40"
            :pic="user.files_urls.avatar_thumbnail"
            :name="user.name"
          />
          <NotificationIcon v-else :type="notificationType" />
          <a :href="notification.link" class="no-underline notification-info" target="_blank">
            <span class="notification-user text-bsb grey-900">
              {{ notification.heading }}
            </span>
            <EditorBlocks :blocks="notification.marked_up_content.blocks" />
          </a>
        </div>
        <div class="notification-time text-sm grey-600">
          {{ prettyDates(notification.created_at, false, true) }}
        </div>
        <Comment v-if="comment" :comment="comment" class="notification-comment" />
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/avatars/Avatar';
  import Checkbox from '@/components/ui/Checkbox';
  import IsReadStatus from '@/containers/catch-up/IsReadStatus';
  import Comment from '@/containers/catch-up/Comment';
  import NotificationIcon from '@/components/ui/NotificationIcon';
  import EditorBlocks from '@/components/editorjs/EditorBlocks';
  import prettyDates from '@/utils/formatting/pretty-date';

  export default {
    name: 'Notification',
    components: {
      Avatar,
      Checkbox,
      IsReadStatus,
      Comment,
      NotificationIcon,
      EditorBlocks,
    },
    props: {
      notification: {
        type: Object,
        required: true,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        hover: false,
        prettyDates,
      };
    },
    computed: {
      user() {
        const n = this.notification;
        return (
          n?.inviter_user ||
          n?.row_comment?.author ||
          n?.tender_offer_row_comment?.author ||
          n?.tender_offer_message?.user ||
          null
        );
      },
      notificationType() {
        return this.notification?.icon_type || 'plus';
      },
      comment() {
        return this.notification.row_comment || this.notification.tender_offer_row_comment;
      },
    },
    methods: {
      handleHover() {
        if (!this.notification.is_read) {
          this.hover = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .notification-container {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid $grey200;
    cursor: pointer;
  }

  .notification {
    padding: 12px 20px;
    display: grid;
    grid-template-columns: 20px 40px 1fr auto;
    grid-gap: 12px;
    align-items: center;
  }

  .notification-content {
    display: contents;
  }

  .notification-user {
  }

  .notification-info {
    display: flex;
    flex-direction: column;
  }

  .notification-comment {
    grid-column-start: 3;
  }
</style>
